














import { Vue, Component } from 'vue-property-decorator';
import DoctorEntityModule from '@/store/doctors/entity';
 
@Component({
    components: {
    },
})
export default class CalendarServices extends Vue {
    get types() {
        return DoctorEntityModule.doctorDetail?.availableTypes || [];
    }
}
